export default "__VITE_ASSET__D0lf4RAJ__"